import CustomerRoutes from "../../apiRoutes/CustomerRoutes";
import { api } from "../ConsumeApiController";


/**
 * Solicita al backend el cálculo de tarifas de delivery para múltiples comercios
 * 
 * @param {number} destinationLat - Latitud del cliente
 * @param {number} destinationLng - Longitud del cliente
 * @param {Array} merchants - Arreglo con los IDs de los comercios [2, 5, 8]
 * @returns {Object} Respuesta estandarizada { success, data, message }
 */
export const calculateDeliveryQuotes = async (destinationLat, destinationLng, merchants) => {
    try {
        const response = await api.post(CustomerRoutes.LOGISTICS.CALCULATE_QUOTES, {
            destination_lat: destinationLat,
            destination_lng: destinationLng,
            merchants: merchants
        });

        if (response.data && response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response?.message || 'Error al cotizar el envío.' };
        }
    } catch (error) {
        console.error("🔥 Error en calculateDeliveryQuotes:", error);
        return { 
            success: false, 
            message: error.response?.data?.message || 'Fallo de conexión al calcular el delivery.' 
        };
    }
};